import React from 'react'
import { times } from 'lodash'
import { SkeletonPlaceholder } from 'carbon-components-react'

const Skeleton = ({ rows = 3 }) =>
  times(rows).map((n) => <SkeletonPlaceholder key={n} />)

export default Skeleton
